<div class="dashboard-container">
  <header class="dashboard-header">
    <div class="header-title">
      <h1 class="text-2xl font-bold">Ta'ang Education Fund Lottery</h1>
    </div>
    <div class="header-actions">
      <select class="year-select" [(ngModel)]="selectedYear" (change)="onYearChange()">
        @for (year of years; track year) {
          <option [value]="year">{{ year }}</option>
        }
      </select>
    </div>
  </header>

  <div class="summary-cards">
    <div class="summary-card">
      <div class="card-icon revenue-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-svg">
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <line x1="2" y1="10" x2="22" y2="10" />
        </svg>
      </div>
      <div class="card-info">
        <span class="card-label">Total Revenue</span>
        <span class="card-value">{{ formatValue(totalRevenue) }}</span>
      </div>
    </div>
    <div class="summary-card">
      <div class="card-icon tickets-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-svg">
          <path d="M2 9V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a3 3 0 0 0 0 6v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a3 3 0 0 0 0-6Z" />
        </svg>
      </div>
      <div class="card-info">
        <span class="card-label">Total Tickets</span>
        <span class="card-value">{{ formatValue(totalTickets) }}</span>
      </div>
    </div>
    <div class="summary-card">
      <div class="card-icon orders-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="icon-svg">
          <circle cx="9" cy="21" r="1" />
          <circle cx="20" cy="21" r="1" />
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
        </svg>
      </div>
      <div class="card-info">
        <span class="card-label">Total Orders</span>
        <span class="card-value">{{ formatValue(totalOrders) }}</span>
      </div>
    </div>
  </div>

  <div class="dashboard-grid">
    <div class="grid-item revenue-card">
      <div class="card-header">
        <h3 class="card-title">{{ 'admin.dashboard.ticketRevenue' | translate }}</h3>
      </div>
      <div class="card-body">
        <apx-chart
          [series]="revenueChart.series!"
          [chart]="revenueChart.chart!"
          [xaxis]="revenueChart.xaxis!"
          [yaxis]="revenueChart.yaxis!"
          [stroke]="revenueChart.stroke!"
          [dataLabels]="revenueChart.dataLabels!"
          [colors]="revenueChart.colors!"
          [fill]="revenueChart.fill!"
          [grid]="revenueChart.grid!"
        ></apx-chart>
      </div>
    </div>

    <div class="grid-item overview-card">
      <div class="card-header">
        <h3 class="card-title">{{ 'admin.dashboard.ticketOverview' | translate }}</h3>
      </div>
      <div class="card-body">
        <apx-chart
          [series]="ticketOverviewChart.series!"
          [chart]="ticketOverviewChart.chart!"
          [labels]="ticketOverviewChart.labels!"
          [dataLabels]="ticketOverviewChart.dataLabels!"
          [plotOptions]="ticketOverviewChart.plotOptions!"
          [colors]="ticketOverviewChart.colors!"
          [legend]="ticketOverviewChart.legend!"
          [responsive]="ticketOverviewChart.responsive!"
        ></apx-chart>
      </div>
    </div>

    <div class="grid-item overview-card">
      <div class="card-header">
        <h3 class="card-title">{{ 'admin.dashboard.orderOverview' | translate }}</h3>
      </div>
      <div class="card-body">
        <apx-chart
          [series]="orderOverviewChart.series!"
          [chart]="orderOverviewChart.chart!"
          [labels]="orderOverviewChart.labels!"
          [dataLabels]="orderOverviewChart.dataLabels!"
          [plotOptions]="orderOverviewChart.plotOptions!"
          [colors]="orderOverviewChart.colors!"
          [legend]="orderOverviewChart.legend!"
        ></apx-chart>
      </div>
    </div>

    <div class="grid-item orders-card">
      <div class="card-header">
        <h3 class="card-title">{{ 'admin.dashboard.orders' | translate }}</h3>
        <div class="filter-tabs">
          <button [class.active]="orderFilter === 'All'" (click)="onOrderFilterChange('All')">{{ 'table.total' | translate }}</button>
          <button [class.active]="orderFilter === 'Pending'" (click)="onOrderFilterChange('Pending')">{{ 'table.statusOpen' | translate }}</button>
          <button [class.active]="orderFilter === 'Confirmed'" (click)="onOrderFilterChange('Confirmed')">{{ 'table.statusConfirmed' | translate }}</button>
          <button [class.active]="orderFilter === 'Failed'" (click)="onOrderFilterChange('Failed')">{{ 'table.statusFailed' | translate }}</button>
        </div>
      </div>
      <div class="card-body">
        <apx-chart
          [series]="ordersBarChart.series!"
          [chart]="ordersBarChart.chart!"
          [xaxis]="ordersBarChart.xaxis!"
          [yaxis]="ordersBarChart.yaxis!"
          [plotOptions]="ordersBarChart.plotOptions!"
          [colors]="ordersBarChart.colors!"
          [grid]="ordersBarChart.grid!"
        ></apx-chart>
      </div>
    </div>

    <div class="grid-item recent-orders-card">
      <div class="card-header border-none">
        <h3 class="card-title">{{ 'admin.dashboard.recentOrders' | translate }}</h3>
        <div class="search-box">
          <input type="text" 
                 [placeholder]="'table.search' | translate" 
                 class="search-input"
                 [(ngModel)]="recentOrdersSearch"
                 (input)="onSearch($event)">
        </div>
      </div>
      <div class="table-container">
        <table class="recent-orders-table">
          <thead>
            <tr>
              <th>{{ 'column.invoiceNo' | translate }}</th>
              <th>{{ 'column.name' | translate }}</th>
              <th>{{ 'column.address' | translate }}</th>
              <th>{{ 'column.status' | translate }}</th>
              <th>{{ 'column.phone' | translate }}</th>
              <th>{{ 'column.screenshot' | translate }}</th>
              <th>{{ 'column.ticketCount' | translate }}</th>
              <th>{{ 'column.action' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @if (isRecentOrdersLoading) {
              <tr>
                <td colspan="7" class="text-center py-8">
                  <div class="loading-spinner-container">
                    <div class="spinner"></div>
                    
                  </div>
                </td>
              </tr>
            } @else if (recentOrders.length === 0) {
              <tr>
                <td colspan="7" class="text-center py-8 text-gray-400 font-medium">
                  No recent orders found
                </td>
              </tr>
            } @else {
              @for (order of recentOrders; track order.id) {
                <tr>
                  <td>{{ order.invoiceno }}</td>
                  <td>{{ order.payment.name }}</td>
                  <td>{{ order.payment.address }}</td>
                 <td>
  <span
    class="status-badge"
    [ngClass]="{
      'confirmed': order.status === '02',
      'failed': order.status === '03',
      'pending': order.status !== '02' && order.status !== '03'
    }"
  >
    {{
      order.status === '02'
        ? 'Confirmed'
        : order.status === '03'
        ? 'Failed'
        : 'Pending'
    }}
  </span>
</td>
                  <td>{{ order.payment.phone }}</td>
                  <td>
                    @if (order.payment.screenshot) {
                      <img [src]="order.payment.screenshot" 
                           class="screenshot-thumbnail" 
                           [alt]="'Payment Screenshot'"
                           (click)="window.open(order.payment.screenshot, '_blank')">
                    } @else {
                      <span class="no-screenshot">No Image</span>
                    }
                  </td>
                  <td>{{ order.payment.ticket?.length || 0 }}</td>
                  <td>
                    <div class="action-buttons">
                      <button class="action-btn edit" (click)="onEditOrder(order)" title="Edit">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="action-svg">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'modal.editOrder' | translate }}</h3>
      <button class="close-icon" (click)="closeModal()">&times;</button>
    </div>

    <form (ngSubmit)="submitOrder()" #orderForm="ngForm">
      <div class="form-body">
        <label for="status">{{ 'modal.status' | translate }}</label>
        <select id="status" name="status" [(ngModel)]="newOrder.status" class="form-input">
          <option value="01">{{ 'table.statusOpen' | translate }}</option>
          <option value="02">{{ 'table.statusConfirmed' | translate }}</option>
          <option value="03">{{ 'table.statusFailed' | translate }}</option>
        </select>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="closeModal()" [disabled]="isSaving">
          {{ 'admin.cancel' | translate }}
        </button>
        <button type="submit" class="btn-create" [disabled]="!orderForm.form.valid || isSaving">
          <span *ngIf="!isSaving">{{ 'modal.updateOrder' | translate }}</span>
          <span *ngIf="isSaving">{{ 'modal.saving' | translate }}</span>
        </button>
      </div>
    </form>
  </div>
</div>


